/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { getCheckFile, getUrl } from '../../viewer/type/viewer-type-util';

/**
 * @import BasePathResolver from '../../basepath/basepath'
 * @import { FileSystemMapper } from '../../file/system'
 * @import ViewerControllerVideoFactory from '../../viewer/controller/viewer-controller-video-factory'
 * @import { ViewerSourceCreator } from '../../viewer/source'
 * @import { ViewerType } from '../../viewer/type'
 */

/**
 * Typ média video.
 * Používá se pouze URL ze serveru bez podpory offline stavu.
 * @implements {ViewerType}
 */
export default class ViewerTypeVideo {
  /**
   * Vytvoří instanci.
   * @param {BasePathResolver} basePathResolver
   * @param {ViewerControllerVideoFactory} controllerFactory Továrna na vytváření nových ovladačů videa.
   * @param {FileSystemMapper} pathMapper
   * @param {ViewerSourceCreator<HTMLVideoElement>} sourceCreator
   */
  constructor(basePathResolver, controllerFactory, pathMapper, sourceCreator) {
    this.basePathResolver = basePathResolver;
    this.controllerFactory = controllerFactory;
    this.pathMapper = pathMapper;
    this.sourceCreator = sourceCreator;
  }

  /** @type {ViewerType['createController']} */
  createController(el, communicatorSettingsGetter) {
    return this.controllerFactory.create(el, communicatorSettingsGetter);
  }

  /** @type {ViewerType['getCheckFile']} */
  getCheckFile(medium) {
    return getCheckFile(medium);
  }

  /** @type {ViewerType['getSourceCreator']} */
  getSourceCreator() {
    return this.sourceCreator;
  }

  /** @type {ViewerType['getUrl']} */
  async getUrl(medium) {
    return await getUrl(this.basePathResolver, medium, this.pathMapper);
  }

  /** @type {ViewerType['isExtractable']} */
  isExtractable() {
    return false;
  }

  /** @type {ViewerType['isOfflineable']} */
  isOfflineable() {
    return true;
  }

  /** @type {ViewerType['isPreloadable']} */
  isPreloadable(medium) {
    return true;
  }

  /** @type {ViewerType['isSeekable']} */
  isSeekable(medium) {
    return true;
  }

  /** @type {ViewerType['isStatic']} */
  isStatic(medium) {
    return false;
  }
}
